/* STRYDE page behaviors. Loaded once per unique src; guarded against double-eval. */
(function () {
  if (window.__strydeLoaded) { window.__strydeInit && window.__strydeInit(); return; }
  window.__strydeLoaded = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    document.body.classList.add('stryde-dark');

    /* --- reveal on scroll --- */
    var revealEls = document.querySelectorAll('[data-s-reveal]:not(.s-init)');
    if (revealEls.length) {
      var ro = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); ro.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      revealEls.forEach(function (el) { el.classList.add('s-init'); ro.observe(el); });
    }

    /* --- subtle parallax on hero / panel backgrounds --- */
    if (!reduced) {
      var pxEls = Array.prototype.slice.call(document.querySelectorAll('[data-s-parallax]:not(.s-init)'));
      pxEls.forEach(function (el) { el.classList.add('s-init'); });
      if (pxEls.length) {
        var ticking = false;
        var onScroll = function () {
          if (ticking) return; ticking = true;
          requestAnimationFrame(function () {
            pxEls.forEach(function (el) {
              var r = el.parentElement.getBoundingClientRect();
              if (r.bottom < 0 || r.top > innerHeight) { ticking = false; return; }
              var p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
              el.style.transform = 'translateY(' + (p * -6) + '%)';
            });
            ticking = false;
          });
        };
        addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
    }

    /* --- sticky feature rail --- */
    document.querySelectorAll('[data-s-feat]:not(.s-init)').forEach(function (sec) {
      sec.classList.add('s-init');
      var items = sec.querySelectorAll('.s-feat-item');
      var imgs = sec.querySelectorAll('.s-feat-visual img');
      var idxEl = sec.querySelector('.s-feat-visual .idx');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = parseInt(e.target.getAttribute('data-i'), 10);
          items.forEach(function (it) { it.classList.toggle('is-active', it === e.target); });
          imgs.forEach(function (im, j) { im.classList.toggle('is-active', j === i); });
          if (idxEl) idxEl.textContent = ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + items.length).slice(-2);
        });
      }, { rootMargin: '-42% 0px -42% 0px' });
      items.forEach(function (it) { io.observe(it); });
    });

    /* --- hotspot pins (tap toggle for touch) --- */
    document.querySelectorAll('.s-pin-dot:not(.s-init)').forEach(function (dot) {
      dot.classList.add('s-init');
      dot.addEventListener('click', function (ev) {
        ev.stopPropagation();
        var pin = dot.parentElement;
        var was = pin.classList.contains('open');
        document.querySelectorAll('.s-pin.open').forEach(function (p) { p.classList.remove('open'); });
        if (!was) pin.classList.add('open');
      });
    });
    if (!window.__strydePinClose) {
      window.__strydePinClose = true;
      document.addEventListener('click', function () {
        document.querySelectorAll('.s-pin.open').forEach(function (p) { p.classList.remove('open'); });
      });
    }

    /* --- buybox --- */
    document.querySelectorAll('[data-s-buybox]:not(.s-init)').forEach(function (box) {
      box.classList.add('s-init');
      var data = JSON.parse(box.querySelector('[data-s-variants]').textContent);
      var state = { color: data.initial.color, color2: data.initial.color, pack: data.initial.pack };
      var color2Wrap = box.querySelector('[data-s-color2]');
      var color2Label = box.querySelector('[data-s-color2-label]');
      var color1Title = box.querySelector('[data-s-color1-title]');
      var mainImg = box.querySelector('[data-s-main] img');
      var priceNow = box.querySelector('[data-s-price-now]');
      var priceWas = box.querySelector('[data-s-price-was]');
      var priceSave = box.querySelector('[data-s-price-save]');
      var atcBtns = document.querySelectorAll('[data-s-atc]');
      var barPrice = document.querySelector('[data-s-bar-price]');
      var barImg = document.querySelector('[data-s-bar-img]');

      function current() {
        return data.variants.filter(function (v) { return v.color === state.color && v.pack === state.pack; })[0];
      }
      /* The Double pack is fulfilled as two separate Single line items so the supplier
         sees two units. An automatic Shopify discount reduces the pair to the bundle price. */
      function single(color) {
        return data.variants.filter(function (v) { return v.color === color && v.pack === 'Single'; })[0];
      }
      function cartItems() {
        if (state.pack !== 'Double') {
          var v = current();
          return v ? [{ id: v.id, quantity: 1 }] : [];
        }
        var a = single(state.color), b = single(state.color2);
        if (!a || !b) return [];
        if (a.id === b.id) return [{ id: a.id, quantity: 2 }];
        return [{ id: a.id, quantity: 1 }, { id: b.id, quantity: 1 }];
      }
      function render() {
        var v = current(); if (!v) return;
        priceNow.textContent = v.price;
        if (v.compare) { priceWas.textContent = v.compare; priceWas.style.display = ''; } else { priceWas.style.display = 'none'; }
        if (v.save) { priceSave.textContent = 'Save ' + v.save; priceSave.style.display = ''; } else { priceSave.style.display = 'none'; }
        var isDouble = state.pack === 'Double';
        if (color2Wrap) color2Wrap.hidden = !isDouble;
        if (color1Title) color1Title.textContent = isDouble ? 'First rig' : 'Color';
        if (color2Label) color2Label.textContent = state.color2;
        box.querySelectorAll('.s-swatch').forEach(function (s) {
          var grp = s.getAttribute('data-group') === '2' ? state.color2 : state.color;
          s.classList.toggle('is-active', s.getAttribute('data-color') === grp);
        });
        box.querySelectorAll('.s-pack').forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-pack') === state.pack);
          var pv = data.variants.filter(function (x) { return x.color === state.color && x.pack === p.getAttribute('data-pack'); })[0];
          if (pv) p.querySelector('.p-price').textContent = pv.price;
        });
        var colorLabel = box.querySelector('[data-s-color-label]');
        if (colorLabel) colorLabel.textContent = state.color;
        if (v.image && mainImg && box.querySelector('.s-buy-thumb.is-active[data-idx="0"]')) mainImg.src = v.image;
        var thumb0 = box.querySelector('.s-buy-thumb[data-idx="0"] img');
        if (v.image && thumb0) thumb0.src = v.image;
        if (v.image && barImg) barImg.src = v.image;
        if (barPrice) barPrice.textContent = v.price;
        atcBtns.forEach(function (b) {
          b.disabled = !v.available;
          b.querySelector('span') ? (b.querySelector('span').textContent = v.available ? b.getAttribute('data-label') : 'Sold out') : null;
        });
      }
      box.querySelectorAll('.s-swatch').forEach(function (s) {
        s.addEventListener('click', function () {
          var isSecond = s.getAttribute('data-group') === '2';
          if (isSecond) { state.color2 = s.getAttribute('data-color'); render(); return; }
          state.color = s.getAttribute('data-color');
          box.querySelectorAll('.s-buy-thumb').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-idx') === '0'); });
          var v = current();
          if (v && v.image && mainImg) mainImg.src = v.image;
          render();
        });
      });
      box.querySelectorAll('.s-pack').forEach(function (p) {
        p.addEventListener('click', function () { state.pack = p.getAttribute('data-pack'); render(); });
      });
      box.querySelectorAll('.s-buy-thumb').forEach(function (t) {
        t.addEventListener('click', function () {
          box.querySelectorAll('.s-buy-thumb').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          if (t.getAttribute('data-idx') === '0') { var v = current(); if (v && v.image) mainImg.src = v.image; }
          else mainImg.src = t.getAttribute('data-src');
        });
      });
      atcBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          var v = current(); if (!v || !v.available) return;
          var items = cartItems(); if (!items.length) return;
          b.disabled = true; b.classList.add('is-loading');
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            window.location.href = '/cart';
          }).catch(function () {
            b.disabled = false; b.classList.remove('is-loading');
            window.location.href = '/cart/add?id=' + items[0].id + '&quantity=' + items[0].quantity + '&return_to=/cart';
          });
        });
      });
      render();

      /* mobile swipe gallery dots */
      var strip = box.querySelector('.s-buy-thumbs');
      var dotsWrap = box.querySelector('[data-s-dots]');
      if (strip && dotsWrap) {
        var slides = box.querySelectorAll('.s-buy-thumb');
        slides.forEach(function () { dotsWrap.appendChild(document.createElement('span')); });
        var dots = dotsWrap.querySelectorAll('span');
        if (dots[0]) dots[0].classList.add('is-on');
        var dTick = false;
        strip.addEventListener('scroll', function () {
          if (dTick) return; dTick = true;
          requestAnimationFrame(function () {
            var i = Math.round(strip.scrollLeft / (strip.scrollWidth / slides.length));
            i = Math.max(0, Math.min(dots.length - 1, i));
            dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
            dTick = false;
          });
        }, { passive: true });
      }

      /* sticky bar visibility */
      var bar = document.querySelector('[data-s-bar]');
      if (bar) {
        var io = new IntersectionObserver(function (entries) {
          bar.classList.toggle('is-show', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
        }, { threshold: 0 });
        io.observe(box);
      }
    });
  }

  window.__strydeInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
